/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
export var NAVIGATION_MENU_REQUEST_OPEN = 'NAVIGATION_MENU_REQUEST_OPEN';
export var NAVIGATION_MENU_OPEN = 'NAVIGATION_MENU_OPEN';
export var NAVIGATION_MENU_REQUEST_CLOSE = 'NAVIGATION_MENU_REQUEST_CLOSE';
export var NAVIGATION_MENU_CLOSE = 'NAVIGATION_MENU_CLOSE';
export var NAVIGATION_MENU_START_CLOSE = 'NAVIGATION_MENU_START_CLOSE';
export var NAVIGATION_MENU_CONFIG_FETCH = 'NAVIGATION_MENU_CONFIG_FETCH';
export var NAVIGATION_MENU_CONFIG_SET = 'NAVIGATION_MENU_CONFIG_SET';
export var NAVIGATION_MENU_CONFIG_CLEAR = 'NAVIGATION_MENU_CONFIG_CLEAR';
export var NAVIGATION_MENU_TOGGLE_SUB_MENU = 'NAVIGATION_MENU_TOGGLE_SUB_MENU';
export var NAVIGATION_MENU_SET_PLATFORM_NAME = 'NAVIGATION_MENU_SET_PLATFORM_NAME';
export var openNavigationMenu = function openNavigationMenu(menuId) {
  return {
    type: NAVIGATION_MENU_REQUEST_OPEN,
    menuId: menuId
  };
};
export var closeNavigationMenu = function closeNavigationMenu(afterCloseAction, switching) {
  return {
    type: NAVIGATION_MENU_REQUEST_CLOSE,
    afterCloseAction: afterCloseAction,
    switching: switching
  };
};
export var startCloseNavigationMenu = function startCloseNavigationMenu() {
  return {
    type: NAVIGATION_MENU_START_CLOSE
  };
};
export var fetchNavigationMenuConfig = function fetchNavigationMenuConfig() {
  return {
    type: NAVIGATION_MENU_CONFIG_FETCH
  };
};
export var setNavigationMenuItems = function setNavigationMenuItems(payload) {
  return {
    type: NAVIGATION_MENU_CONFIG_SET,
    payload: payload
  };
};
export var clearNavigationMenuItems = function clearNavigationMenuItems() {
  return {
    type: NAVIGATION_MENU_CONFIG_CLEAR
  };
};
export var toggleSubMenu = function toggleSubMenu(linkId) {
  return {
    type: NAVIGATION_MENU_TOGGLE_SUB_MENU,
    linkId: linkId
  };
};
export var setPlatformName = function setPlatformName(platformName) {
  return {
    type: NAVIGATION_MENU_SET_PLATFORM_NAME,
    platformName: platformName
  };
};